import { createSlice } from '@reduxjs/toolkit'

import { feedState } from './feed.type'

const initialState: feedState = {
  loading: false,
  detailPost: null,
  commentPost: null,
  feedUpdate: null,
}

const feedSlice = createSlice({
  name: 'feed',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setDetailPost: (state, action) => {
      state.detailPost = action.payload
    },
    setCommentPost: (state, action) => {
      state.commentPost = action.payload
    },
    setFeedUpdate: (state, action) => {
      state.feedUpdate = action.payload
    },
  },
  extraReducers: () => {},
})

export const feedActions = feedSlice.actions
const feedReducer = feedSlice.reducer
export default feedReducer
